function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.79,
  y1: 1,
  x2: 0.303,
  y2: 0.166,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f23e9f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6c2196"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_122",
  "data-name": "Group 122",
  transform: "translate(-140 -226)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_18",
  "data-name": "Ellipse 18",
  cx: 39,
  cy: 39,
  r: 39,
  transform: "translate(149 235)",
  fill: "url(#linear-gradient)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_19",
  "data-name": "Ellipse 19",
  transform: "translate(140 226)",
  fill: "none",
  stroke: "#cc369c",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 48,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 48,
  cy: 48,
  r: 46,
  fill: "none"
})));

var SvgRecord = function SvgRecord(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecord, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Record.6420533f.svg";
export { ForwardRef as ReactComponent };